const BlogType = {
  GET_BLOGS: 'GET_BLOGS',
  GET_BLOG: 'GET_BLOG',
  CREATE_BLOG: 'CREATE_BLOG',
  UPDATE_BLOG: 'UPDATE_BLOG',
  UPLOAD_BUSINESS_STUDY_FILE: 'UPLOAD_BUSINESS_STUDY_FILE',
}

export default BlogType
